import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { useUserAction } from '../../../helpers/custom-hooks';

// Helper function to create and append a script tag
const loadScript = (src) => {
  // Check if the script already exists
  if (document.querySelector(`script[src="${src}"]`)) {
    return; // Script is already in the document, so do nothing.
  }
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
};

const AdScriptsLoader = ({ enableAdpushup, isAdpush, IsBQPrimeBrandStudio, pageType }) => {
  const hasUserAction = useUserAction();
  const hasLoaded = useRef(false);

  useEffect(() => {
    const isPromotionalAdPage =
      window?.location?.pathname === '/ad/detail' ||
      window?.location?.pathname === '/ad/misc' ||
      window?.location?.pathname.includes('/lite');

    // This effect runs only once on the first scroll event
    if (hasUserAction && !hasLoaded.current && !isPromotionalAdPage) {
      hasLoaded.current = true;
      // 1. Initialize all ad-related command queues
      window.googletag = window.googletag || { cmd: [] };
      window.adpushup = window.adpushup || { que: [] };

      // 2. Load the GPT script (always loaded on scroll)
      loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js');

      // 3. Conditionally load the AdPushup script
      if (enableAdpushup && isAdpush && !IsBQPrimeBrandStudio) {
        loadScript('//cdn.adpushup.com/46821/adpushup.js');
      }

      // 4. Load the DFP Audience Pixel on 'story-page'
      if (pageType === 'story-page') {
        const a = String(Math.floor(Math.random() * 10000000000000000));
        new Image().src =
          'https://pubads.g.doubleclick.net/activity;dc_iu=/21713057369/DFPAudiencePixel;ord=' +
          a +
          ';dc_seg=7798805408?';
      }
    }
  }, [hasUserAction, enableAdpushup, isAdpush, pageType]);

  return null;
};

const mapStateToProps = (state) => ({
  enableAdpushup: get(state, ['qt', 'config', 'features', 'enable_adpushup'], false),
  isAdpush: get(state, ['qt', 'config', 'features', 'isAdpush'], false),
  IsBQPrimeBrandStudio: get(state, ['qt', 'config', 'features', 'IsBQPrimeBrandStudio'], false),
  pageType: get(state, ['qt', 'pageType'], null),
});

export default connect(mapStateToProps)(AdScriptsLoader);
